import { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import { saveAs } from 'file-saver';
import { pdf } from "@react-pdf/renderer";
import { getActiveProgramById, getGroupSession } from "../../services/ActivePrograms";
import moment from "moment";
import GroupSessionNotePDF from "./GroupSessionNotePDF";

const GroupChartCapture = ({ setDownloadPDF, downloadPDF, state }) => {
  const chartRef1 = useRef(null);
  const chartRef2 = useRef(null);
  const chartRef3 = useRef(null);
  const chartRef4 = useRef(null);
  const chartRef5 = useRef(null);
  const chartRef6 = useRef(null);
  const [session, setSession] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [programDetails, setProgramDetails] = useState(null);
  const getSession = async () => {
    try {
      const res = await getGroupSession(
        state?._id,
        state?.programId,
      );
      setSession(res?.data?.data);
    } catch (error) {
      console.error("Error fetching session data:", error);
    }
  };
  const getProgram = async () => {
    try {
      const res = await getActiveProgramById(state?.programId);
      setProgramDetails(res?.data?.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (downloadPDF) {
      getSession();
      getProgram();
    }
  }, [downloadPDF]);

  const generatePDF = async (imageData,chartImage) => {
    try {
      setIsGenerating(true);
      const blob = await pdf(
        <GroupSessionNotePDF
          chartImages={imageData} 
          concernImage={chartImage}
          state={state}
          programDetails={programDetails}
          session={session}
        />
      ).toBlob();
      
      const fileName = `group_note.pdf`;
      saveAs(blob, fileName);
      setDownloadPDF(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  useEffect(() => {
    if (!downloadPDF || !session || isGenerating) return;


    const ctxs = [chartRef1.current.getContext("2d"),chartRef2.current.getContext("2d"),chartRef3.current.getContext("2d"),chartRef4.current.getContext("2d"),chartRef5.current.getContext("2d")];
    const charts = [];
    for (let index = 0; index < session?.groupSession?.healthMetrics.length; index++) {
      const ctx = ctxs[index];
      console.log("front ctx", ctx);
      const item = session?.groupSession?.healthMetrics[index];
      let data = [];
      
      if(item.value === "Blood Pressure"){
        data = session?.objectives
        .filter((obj) => obj[item.key].diastolic)
        .map((obj) => {
          return {
            name: obj.name,
            value: obj[item.key].diastolic,
            value2: obj[item.key].systolic,
          };
        });
        charts.push(new Chart(ctx, {
          type: "line",
          data: {
            labels: data.map(item => ""),
            datasets: [
              {
                label: "Systolic",
                data: data.map(item => item.value2),
                backgroundColor: "rgba(0, 200, 180, 0.2)",
                borderColor: "rgba(0, 200, 180, 1)",
                tension: 0.4,
                borderWidth: 12,
                fill: true,
              },
              {
                label: "Diastolic",
                data: data.map(item => item.value),
                backgroundColor: "rgba(100, 100, 100, 0.2)",
                borderColor: "rgba(100, 100, 100, 1)",
                tension: 0.4,
                borderWidth: 12,
                fill: true,
              },
            ],
          },
          options: {
            responsive: true,
            plugins: {
              legend: {
                display: false,
              },
            },
            scales: {
              y: {
                // min: 0,
                // max: 200,
                ticks: {
                  // stepSize: 40,
                  font: {
                    size: 38,
                  },
                },
              },
              x: {
                grid: {
                  display: false,
                },
                ticks: {
                  font: {
                    size: 38,
                  },
                },
              },
            },
          },
        }));
      }
      else {
        data = session?.objectives
        .filter((obj) => obj[item.key])
        .map((obj) => {
          return { name: obj.name, value: obj[item.key] };
        }); 
        charts.push(new Chart(ctx, {
          type: "line",
          data: {
            labels: data.map(item => ""),
            datasets: [
              {
                label: item.value,
                data: data.map(item => item.value),
                backgroundColor: "rgba(0, 200, 180, 0.2)",
                borderColor: "rgba(0, 200, 180, 1)",
                tension: 0.4,
                borderWidth: 12,
                fill: true,
              },
            ],
          },
          options: {
            responsive: true,
            plugins: {
              legend: {
                display: false,
              },
              title: {
                display: false,
              },
            },
            scales: {
              y: {
                // min: 0,
                // max: 200,
                ticks: {
                  //  stepSize: 40,
                  font: {
                    size: 38,
                  },
                },
              },
              x: {
                grid: {
                  display: false,
                },
                ticks: {
                  font: {
                    size: 38,
                  },
                },
              },
            },
          },
        }));
      }
     
    }
    charts.push(new Chart(chartRef6.current.getContext("2d"), {
      type: "bar",
      data: {
        labels: session?.groupSession?.concerns.map((item,index) => String.fromCharCode(65 + index)),
        datasets: [{
          label: 'Concerns',
          data: session?.groupSession?.concerns.map(item => item.numberOfMembers),
          backgroundColor: [
            '#4bc1af',
          ]
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            ticks: {
              font: {
                size: 55,
              },
            },
          },
          x: {
            grid: {
              display: false,
            },
            ticks: {
              font: {
                size: 55,
              },
            },
          },
        },
      },
    }));

    setTimeout(async () => {
      try {
        const imageData = [];
        for (let index = 0; index < charts.length; index++) {
          if (index === 0) {
            imageData.push(chartRef1.current.toDataURL());
          }
          else if (index === 1) {
            imageData.push(chartRef2.current.toDataURL());
          }
          else if (index === 2) {
            imageData.push(chartRef3.current.toDataURL());
          }
          else if (index === 3) {
            imageData.push(chartRef4.current.toDataURL());
          }
          else if (index === 4) {
            imageData.push(chartRef5.current.toDataURL());
          }
        }
        await generatePDF(imageData,chartRef6.current.toDataURL());
      } catch (error) {
        console.error("Error capturing chart images:", error);
      }
    }, 1000);
  
    return () => {
      charts.forEach(chart => {
        chart.destroy();
      });
    };
  
  }, [downloadPDF, session, isGenerating]);

  return (
    <>
      <canvas
        ref={chartRef1}
        width={700}
        height={450}
        style={{ display: "none" }}
      />
      <canvas
        ref={chartRef2}
        width={700}
        height={450}
        style={{ display: "none" }}
      />
      <canvas
        ref={chartRef3}
        width={700}
        height={450}
        style={{ display: "none" }}
      />
      <canvas
        ref={chartRef4}
        width={700}
        height={450}
        style={{ display: "none" }}
      />
      <canvas
        ref={chartRef5}
        width={700}
        height={450}
        style={{ display: "none" }}
      />
      <canvas
        ref={chartRef6}
        width={500}
        height={450}
        style={{ display: "none" }}
      />
    </>
  );
};

export default GroupChartCapture;
